import { render, staticRenderFns } from "./SoundViewer.vue?vue&type=template&id=040c33b4&scoped=true&"
import script from "./SoundViewer.vue?vue&type=script&lang=js&"
export * from "./SoundViewer.vue?vue&type=script&lang=js&"
import style0 from "./SoundViewer.vue?vue&type=style&index=0&id=040c33b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040c33b4",
  null
  
)

export default component.exports